import { makeStyles } from "@material-ui/core";
import { DESKTOP_BREAKPOINT } from "../../../consts";

export const useStyles = makeStyles((theme) => ({
  gaugeContainer: {
    width: "100%",
    textAlign: "center",
    position: "relative",
  },
  gaugeSvg: {
    width: "100%",
    height: "auto",
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {},
  },
  gaugeGreyArc: {
    stroke: "#E0E0E0",
    strokeWidth: 20,
    fill: "none",
  },
  gaugeGreyArc2: {
    stroke: "#fafafa",

    strokeWidth: 24,
    fill: "none",
  },
  gaugeGreenArc: {
    stroke: "green",
    strokeWidth: 20,
    fill: "none",
  },
  gaugeDottedArc: {
    stroke: "#808080",
    strokeWidth: ".5px",
    fill: "none",
    strokeDasharray: "2,2",
  },
  gaugeWhiteCircle: {
    fill: "white",
    stroke: "green",
    strokeWidth: 3.5,
  },
  gaugeCircle: {
    fill: "#808080",
  },
  gaugeRatingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translateX(-50%)",
  },
  gaugeRatingText: {
    color: "#000",
    fontWeight: 500,
    fontSize: "16px",
  },
  gaugeBigScore: {
    color: "#008000",
    fontWeight: 700,
    fontSize: "42px",
  },
  gaugeScoreLabel: {
    color: "#008000",
    fontWeight: 500,
    fontSize: "16px",
  },
}));

export const useAboutStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    gap: "24px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      flexDirection: "column",
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 16,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 600,
  },
  editIcon: {
    cursor: "pointer",
  },
  label: {
    fontWeight: 400,
    fontSize: 14,
    marginBottom: 4,
    color: "#666666",
  },
  textRow: {
    marginBottom: 16,
    "& .text": {
      color: "#666666 !important",
      fontSize: "14px !important",
      fontFamily: "'Inter', sans-serif !important",
    },
  },
  infoGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: 24,
    marginTop: 24,
  },
  infoItem: {
    flex: "1 1 30%",
    minWidth: 200,
  },
  videoWrapper: {
    width: "272px",
    minWidth: "250px",

    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "100%",
      maxWidth: "100%",
    },
  },
  videoThumbnail: {
    width: "100%",
    minHeight: "150px",
    maxHeight: "200px",
    borderRadius: 2,
    objectFit: "contain",
  },
  videoOverlayIcon: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: 32,
    height: 32,
    transform: "translate(-50%, -50%)",
  },
  changeVideoText: {
    fontSize: 12,
    color: "#777",
    textAlign: "center",
    marginTop: 6,
    cursor: "pointer",
  },

  uploadVideo: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    backgroundColor: "#F5F5F5",
    border: "1px solid #C4C4C4",
    width: "272px",
    minWidth: "250px",
    minHeight: "100px",
    padding: "16px",
    borderRadius: "4px",
    cursor: "pointer",
    "& > p": {
      color: "#666666",
      fontSize: "14px",
      fontFamily: "Roboto",
    },

    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "100%",
      maxWidth: "100%",
    },
  },

  editableContainer: {
    width: "100%",
    "& .MuiSelect-select": {
      border: "1px solid #C4C4C4 !important",
      borderRadius: "4px",
      padding: "8px 18px 8px 8px !important",
      color: "#666666",
      fontWeight: 500,
      width: "100%",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C4C4C4 !important",
    },
  },
}));
